export default "__VITE_ASSET__5eb361f2__"